export const BRAND = {
  name: "MANUTIO",
  tagline: "Tutto sotto controllo.",
} as const;
